import { otherApiClient } from ".";
export const postPOD = async (params)=>{
    const { data  } = await otherApiClient.market.post("/pod", params);
    return data;
};
export const generateUploadUrl = async (params)=>{
    const { data  } = await otherApiClient.market.post("/pod/generate-upload-url", params);
    return data;
};
export const getPODById = async (id)=>{
    const { data  } = await otherApiClient.market.get("/pod/".concat(id));
    return data;
};
export const addPodToCart = async (params)=>{
    const { data  } = await otherApiClient.market.post("/carts/current/pod", params);
    return data;
};
